"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getAllSubFolderIds_1 = require("../selectors/getAllSubFolderIds");
var localFolderOperations_1 = require("owa-mail-folder-store/lib/actions/localFolderOperations");
var actionTypes_1 = require("owa-mail-store/lib/actions/actionTypes");
var deleteFolderService_1 = require("owa-mail-store/lib/services/deleteFolderService");
var undoActions = require("owa-mail-undo");
var owa_service_error_1 = require("owa-service-error");
var folderNameToId_1 = require("owa-session-store/lib/utils/folderNameToId");
var owa_strings_1 = require("owa-strings");
var owa_mail_strings_1 = require("owa-strings/owa-mail-strings");
var legacy_1 = require("satcheljs/lib/legacy");
var stitch_1 = require("satcheljs/lib/legacy/stitch");
function deleteFoldersFromFolderTable(state, folderIdsToDelete) {
    // delete each folder from local store
    folderIdsToDelete.forEach(function (folderId) {
        state.folderTable.delete(folderId);
    });
}
exports.deleteFoldersFromFolderTable = deleteFoldersFromFolderTable;
exports.default = legacy_1.action('deleteFolder')(function deleteFolder(folders, folderId, softDelete) {
    // Only need to worry about removing the top-most folder from its parent's
    // list of children
    var folderToDelete = folders.folderTable.get(folderId);
    undoActions.clearLastUndoableAction();
    localFolderOperations_1.removeFolderFromParentFolder(folders, folderToDelete);
    var folderIdsToDelete = getAllSubFolderIds_1.default(folderToDelete.FolderId.Id);
    // TODO: VSO 11909: Handle undo for destructive mail actions
    var actionResponse = owa_service_error_1.handleServiceError('deleteFolderWithoutConfirmation', owa_strings_1.format(owa_mail_strings_1.default.errorDeletingFolder, folderToDelete.DisplayName), function () {
        return deleteFolderService_1.default(folderId, softDelete);
    });
    // raise the stitch to notify list view component to update the list view store
    stitch_1.raiseAction(actionTypes_1.actionNames.DeleteFolderAction)(folderIdsToDelete);
    if (softDelete) {
        // If the item is in the deleted items folder or in PublicFolder or in archived deleted items folder, perform a softdelete.
        deleteFoldersFromFolderTable(folders, folderIdsToDelete);
    }
    else {
        var deletedItemsFolderId = folderNameToId_1.default('deleteditems');
        localFolderOperations_1.moveFolderToParentFolder(folders, folderToDelete, deletedItemsFolderId);
    }
    return actionResponse;
});
//# sourceMappingURL=deleteFolder.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-folder-store/lib/actions/deleteFolder.js
// module id = 4731
// module chunks = 23